<template>
  <div class="zg-cell clearfix">
    <div class="fl">
      <el-image v-if="isShowImage" class="m-r10" :src="FILE_ROOT + imgSrc" :style="imgStyle" lazy>
        <div slot="placeholder" class="image-slot">
          <el-image :src="imgPlaceholder" :style="imgStyle"></el-image>
        </div>
        <div slot="error" class="image-slot">
          <el-image :src="imgPlaceholder" :style="imgStyle"></el-image>
        </div>
      </el-image>
      <div class="fr text-left" :style="{ width: descWidth, minHeight: '60px' }">
        <div
          class="title c-3 two-line"
          :style="{ maxWidth: titleHeight }"
          :class="[canRouter ? 'router' : '']"
        >
          {{ name || '' }}
        </div>
        <div v-if="isShowLabel" class="c-main f-12 m-t10" :style="{ maxWidth: titleHeight }">
          <span style="background-color: #F8F8F8; border: 1px solid #EDC9C9">{{ '不定规格' }}</span>
        </div>
        <div class="c-9 f-12 m-t10 single-line" :style="{ maxWidth: titleHeight }">
          {{ desc + descWeight || '' }}
        </div>
        <div
          v-if="supplierName"
          class="c-9 f-12 m-t5 single-line"
          :style="{ maxWidth: titleHeight }"
        >
          {{ supplierName }}
        </div>
        <div v-if="tip !== ''" class="c-9 f-12 m-t10" :style="{ maxWidth: titleHeight }">
          {{ tip }}
        </div>
      </div>
    </div>
    <slot name="ps"></slot>
  </div>
</template>

<script>
import { FILE_ROOT } from '../common/constants/'

export default {
  name: 'ZgCell',

  components: {},
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    supplierName: {
      type: String,
      default: ''
    },
    weight: {
      type: Number,
      default: 0
    },
    tip: {
      type: String,
      default: ''
    },
    isShowLabel: {
      type: Boolean,
      default: false
    },
    isShowImage: {
      type: Boolean,
      default: true
    },
    canRouter: {
      type: Boolean,
      default: true
    },
    titleHeight: {
      type: String,
      default: '180px'
    },
    descWidth: {
      type: String,
      default: '180px'
    },
    imgStyle: {
      type: Object,
      default: () => ({ width: '60px', height: '60px' })
    }
  },
  data() {
    return {
      FILE_ROOT,
      imgPlaceholder: require('@/assets/preload-img-placeholder.svg')
    }
  },
  computed: {
    descWeight() {
      return this.weight > 0 ? `（${this.weight}吨）` : ''
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.zg-cell {
  font-size: 14px;
  .title {
    max-height: 38px;
    &:hover.router {
      cursor: pointer;
      color: red;
    }
  }
  .ps {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
